import L from 'leaflet';
import DisplayIconSVG from '../../../style/assets/map/display.svg';

const TCMCreateDisplayIcon = new L.Icon({
    iconUrl: DisplayIconSVG,
    iconSize: [60, 75],
});

export default TCMCreateDisplayIcon;
